import { SearchParams } from "../types";

export const buildSearchParams = (params: SearchParams): string => {
  return encodeURIComponent(JSON.stringify(params));
};

export const buildSelectQuery = (fields: string[]): string => {
  return fields.join(",");
};

export const createUserFilter = (userId: string) => ({
  type: "or",
  value: [
    { type: "equals", attribute: "assignedUserId", value: userId },
    { type: "equals", attribute: "createdById", value: userId },
  ],
});

export const createParentFilter = (parentId: string, parentType: string) => [
  { type: "equals", attribute: "parentId", value: parentId },
  { type: "equals", attribute: "parentType", value: parentType },
];

export const createActiveUsersFilter = () => [
  { type: "primary", value: "active" },
];

export const extractErrorMessage = (
  error: any,
  defaultMessage: string
): string => {
  if (
    error?.response?.data?.messageTranslation?.label === "validationFailure"
  ) {
    const field = error.response.data.messageTranslation.data?.field;
    return field ? `Ошибка валидации: ${field}` : "Ошибка валидации";
  }
  if (
    error?.response?.data?.messageTranslation?.label ===
    "cannotRelateNonExisting"
  ) {
    return "Пользователь не существует";
  }
  return error?.response?.data?.message || error?.message || defaultMessage;
};

export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
};

export const downloadBlob = (blob: Blob, fileName: string): void => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
